module.exports = __webpack_public_path__ + "static/media/add.c1b656f7.png";